import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { getChatsByTenant } from "../store/chats/thunks";
import { selectChatsState } from "../store/chats/selectors";

export const useTenantChats = () => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { chatsByTenants, loading, selectedChatId, newMessageCount } =
    useSelector(selectChatsState);

  useEffect(() => {
    if (selectedTenantId && !chatsByTenants[selectedTenantId]) {
      dispatch(getChatsByTenant({ tenant_id: selectedTenantId }));
    }
  }, [selectedTenantId, chatsByTenants, dispatch]);

  const { chats } = useMemo(() => {
    return {
      chats: Object.keys(chatsByTenants[selectedTenantId] || {}).map(
        (key) => chatsByTenants[selectedTenantId][key]
      ),
    };
  }, [chatsByTenants, selectedTenantId]);

  const selectedChat = useMemo(() => {
    return chatsByTenants?.[selectedTenantId]?.[selectedChatId];
  }, [chats, selectedChatId, selectedTenantId]);

  return {
    chats,
    loading,
    selectedTenantId,
    selectedChat,
    selectedChatId,
    newMessageCount,
  };
};
